var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.0595V15.75C24 16.7446 23.6049 17.6984 22.9016 18.4017C22.1984 19.1049 21.2446 19.5 20.25 19.5H3.75C2.75544 19.5 1.80161 19.1049 1.09835 18.4017C0.395088 17.6984 0 16.7446 0 15.75V5.0595L11.619 11.8965C11.7344 11.9646 11.866 12.0005 12 12.0005C12.134 12.0005 12.2656 11.9646 12.381 11.8965L24 5.0595ZM20.25 4.6429e-08C21.1727 -0.000145074 22.0631 0.33991 22.7508 0.95511C23.4385 1.57031 23.8753 2.41746 23.9775 3.3345L12 10.38L0.0225002 3.3345C0.124737 2.41746 0.561486 1.57031 1.24919 0.95511C1.9369 0.33991 2.82728 -0.000145074 3.75 4.6429e-08H20.25Z",
    fill: "#041018"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.a5cc0683.svg";
export { ForwardRef as ReactComponent };